import React from "react";

export function HeadingText({ text }) {
    return (
        <div className="mt-4 mb-2 baseText !font-medium max-w-xs">{text}</div>
    );
}
export function HeadingTextLight({ text }) {
    return (
        <strong><div className="mt-4 mb-2 baseText font-medium max-w-xs text-gray-500">{text}</div></strong>
    );
}

export function Paragraph({ text }) {
    return <p className="baseText text-navLink mb-2">{text}</p>;
}
export const LableValueCon = ({ lable, value }) => {
    return (
        <div className="flex flex-row gap-1">
            <strong><p className="baseText font-medium max-w-xs text-gray-500">{lable}: </p></strong>
            <p className="baseText text-navLink">{value} </p>
        </div>
    )
}
export function BulletList({ items }) {
    return (
        <ul className="list-disc pl-5 baseText text-navLink">
            {items.map((item, index) => (
                <li key={index}><strong><p className="baseText text-navLink">{item.value}</p></strong></li>
            ))}
        </ul>
    );
} 